<template>
  <div class="styjCon">
    <div v-if="styjList.length>0">
        <!-- <div class="jingCov" @click="styjshow">
            <img src="@/assets/images/yj.png" alt="" class="iimg">
            <div class="yiright">
                <span class="tit" v-if="alertContentValue">{{alertContentValue.title}}</span>
                <span class="tit" v-else>暂无预警信息</span>
            </div>
        </div> -->
        <div class="block shntai" @click="styjshow">
          <vue-seamless-scroll :data="styjList"  :class-option="optionSetting">
              <div >
                <el-timeline>
                  <el-timeline-item hide-timestamp placement="top" v-for="(item,index) in styjList" :key="index">
                    <div class="el-timeline-item__timestamp2 is-top">
                       <span>{{ item.deviceName }} <span style="float:right;margin-right:2%;">{{ item.alertTime }}</span> </span> 
                    </div>
                    <div class="stCov">
                        <span v-for="(val,index) in item.contentStrList" :key="index" :class="item.readStatus='high'?'textshow2':(item.readStatus='low'?'textshow3':'textshow')">
                          {{val}}
                        </span>
                    </div>
                  </el-timeline-item>
                </el-timeline>
              </div>
          </vue-seamless-scroll>
        </div>
    </div>
    <img v-else src="@/assets/images/nonenum.png" alt="" style="margin:54px 0px;">
    <el-dialog
      width="70%"
      top="160px"
      :visible.sync="styjzddialogTableVisible"
      :modal-append-to-body="false"
    >
      <div class="tz_covstyj_chanye" style="height: 670px">
        <img
          src="@/assets/images/guanbi.png"
          class="guanbiann"
          @click="qcguanbi"
          alt=""
        />
        <div class="tz_cov_topchanye">
          <span class="tz_cov_top_tit">生态预警监测</span>
        </div>
        <el-row class="tz_cov_topyqjs">
          <el-col :span="12">
            <div class="grid-content bg-purple ycboxlt4">
              <img src="@/assets/images/tcwix.png" class="tcyqimg"  alt="">
            </div>
          </el-col>
          <el-col :span="12">
            <div class="jingCov">
                <img src="@/assets/images/yj.png" alt="" class="iimg">
                <div class="yiright">
                    <span class="tit" v-if="alertContentValue">{{alertContentValue.title}}</span>
                    <span class="tit" v-else>暂无预警信息</span>
                </div>
            </div>
            <div class="yjList" style="margin-top:20px;">
              <div v-for="(item,index) in styjList" :key="index">
                <el-timeline>
                  <el-timeline-item hide-timestamp placement="top"  color="#01E393">
                    <div class="el-timeline-item__timestamp2 is-top">
                        <span>{{ item.deviceName }} <span style="float:right;margin-right:2%;">{{ item.alertTime }}</span> </span> 
                      </div>
                    <div  class="stCov">
                        <span v-for="(val,index) in item.contentStrList" :key="index" :class="item.readStatus='high'?'textshow2':(item.readStatus='low'?'textshow3':'textshow')">
                            {{val}}
                          </span>
                    </div>
                  </el-timeline-item>
                </el-timeline>
              </div>
            </div>
            <el-pagination
              @current-change="handleCurrentcqoutChange"
              background
              style="margin-top:20px;"
              layout="prev, pager, next"
              :total="totalValue">
            </el-pagination>
          </el-col>
        </el-row>
        
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { envAlertPage } from'@/api'
export default {
  props:{
    auths:String,
    farmId:String,
  },
  name: "HelloWorld",
  data() {
      return {
          styjzddialogTableVisible: false,
          styjList:[],
          alertContentValue:'',
          pageSize:9,
          pageNo:1,
          areaId:'101100303',
          totalValue:'',
          yjVlaueList:{},
      };
  },
  computed:{
    optionSetting(){
      return{
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        autoPlay: true, // 是否自动滚动
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      }
    },
  },
  mounted() { // 渲染视频
    this.alertListApi()
  },
  methods:{
      qcguanbi() {
        this.styjzddialogTableVisible = false;
      },
      styjshow() {
          this.styjzddialogTableVisible = true;
      },
      alertListApi(){
        envAlertPage(this.farmId,this.pageNo,this.pageSize).then(res=>{
          this.alertContentValue = res.result.redAlert
          this.styjList = res.result.alertRecords.records
          this.yjVlaueList = res.result.alertRecords
          this.totalValue = res.result.alertRecords.total
          if (this.yjVlaueList) {
            this.$emit("yj-souw",this.yjVlaueList)
          }
        })
      },
      handleCurrentcqoutChange(currentPage){
        this.pageNo = currentPage;
        envAlertPage(this.farmId,this.pageNo,this.pageSize).then(res=>{
          this.alertContentValue = res.result.redAlert
          this.styjList = res.result.alertRecords.records
          this.totalValue = res.result.alertRecords.total
        })
      },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "@/assets/css/home.css";
.styjCon{
    width: 100%;
    height: 300px;
    overflow: hidden;
}
/* 定义滚动条样式 */
.styjCon::-webkit-scrollbar {
	width: 2px;
	height: 2px;
	background-color: rgba(240, 240, 240, 0.1);
}
/*定义滚动条轨道 内阴影+圆角*/
.styjCon::-webkit-scrollbar-track {
	box-shadow: inset 0 0 0px rgba(240, 240, 240, .0);
	border-radius: 10px;
	background-color: rgba(240, 240, 240, .0);
}
/*定义滑块 内阴影+圆角*/
.styjCon::-webkit-scrollbar-thumb {
	border-radius: 10px;
	box-shadow: inset 0 0 0px rgba(36, 132, 109, .8);
	background-color: rgba(36, 132, 109, .8);
}
.yjList{
  width: 95%;
    height: 455px;
    overflow: auto;
}
/* 定义滚动条样式 */
.yjList::-webkit-scrollbar {
	width: 2px;
	height: 2px;
	background-color: rgba(240, 240, 240, 0.1);
}
/*定义滚动条轨道 内阴影+圆角*/
.yjList::-webkit-scrollbar-track {
	box-shadow: inset 0 0 0px rgba(240, 240, 240, .0);
	border-radius: 10px;
	background-color: rgba(240, 240, 240, .0);
}
/*定义滑块 内阴影+圆角*/
.yjList::-webkit-scrollbar-thumb {
	border-radius: 10px;
	box-shadow: inset 0 0 0px rgba(36, 132, 109, .8);
	background-color: rgba(36, 132, 109, .8);
}
.jingCov{
  width: 94%;
  height: 65px;
  margin: 0 auto;
  overflow: hidden;
  text-align: left;
  background:linear-gradient(to right, rgba(255, 102, 102, 0.2), rgba(255, 102, 102, 0));
  .iimg{
    width: 56px;
    height: 64px;
    float: left;
  }
  .yiright{
    width:84%;
    height: 64px;
    line-height: 64px; 
    // background: rgba(255, 102, 102, 0.2);
    cursor: pointer;
    float: left;
    .tit{
      width:100%;
      display: block;
      margin-left: 3%;
      font-size: 18px;
      color:#ffb138 ;
      white-space: nowrap;      /* 保持文本在一行内显示 */
      overflow: hidden;         /* 超出容器部分隐藏 */
      text-overflow: ellipsis; 
    }
  }
}
.block{
  width: 94%;
  height: 260px;
  padding-bottom: 10px;
  padding-top: 10px;
  overflow: auto;
  margin: 0 auto;
  margin-top: 20px;
}
/* 定义滚动条样式 */
.block::-webkit-scrollbar {
	width: 0px;
	height: 0px;
	background-color: rgba(240, 240, 240, 0.1);
}
/*定义滚动条轨道 内阴影+圆角*/
.block::-webkit-scrollbar-track {
	box-shadow: inset 0 0 0px rgba(240, 240, 240, .0);
	border-radius: 10px;
	background-color: rgba(240, 240, 240, .0);
}
/*定义滑块 内阴影+圆角*/
.block::-webkit-scrollbar-thumb {
	border-radius: 10px;
	box-shadow: inset 0 0 0px rgba(36, 132, 109, .8);
	background-color: rgba(36, 132, 109, .8);
}
.stCov{
  width: 96.5%;
  min-height: 60px;
  text-align: left;
  padding-left: 3%;
 cursor: pointer;
  background: rgba(0,24,3,0.65);
  border: 1px solid #00432B;
  .textshow{
    width: 100%;
    font-size: 16px;
    color: #dfdfdf;
    display: block;
    line-height: 30px;
  }
  .textshow2{
    width: 100%;
    font-size: 14px;
    color: #ffb138;
    display: block;
    line-height: 30px;
  }
  .textshow3{
    width: 100%;
    font-size: 16px;
    color: #00d7ff ;
    display: block;
    line-height: 30px;
  }
}
// 弹出开始
:deep .el-dialog {
    position: relative;
    margin: 0 auto;
    background: none;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0, 29, 20,0.9);
    box-sizing: border-box;
    width: 50%;
    /* margin-left: 22%; */
}
:deep .el-dialog__header{
	display: none;
}
.tz_covstyj_chanye{
	width: 100%;
	height: 42vw;
	/* background: url(../../assets/images/tccovbak.png) no-repeat;
    background-size: 100% 100%; */
    background: rgb(1 26 12 / 70%);
    border-radius: 10px;
    border: 1px solid #339D94;
    text-align: center;
    overflow: hidden;
    box-shadow: 0px 0px 30px 0px rgba(14,252,255,0.8);
	position: relative;
	overflow: hidden;
}
.guanbiann{
	width: 28px;
	height: 28px;
	position: absolute;
	right: 2%;
	top: 0.5vw;
	z-index: 9999999999;
	cursor: pointer;
}
.tz_cov_topchanye{
	width: 100%;
	height:48px;
	background: url(../../assets/images/tctopback.png)no-repeat ;
	background-size: 100% 100%;
	text-align: center;
	line-height: 48px;
	margin-bottom: 20px;
}
.tz_cov_top_tit{
	font-size: 20px;
    font-family: douyuFont;
    color: #fff;
    text-align: center;
}
.tcgldw{
	font-size: 18px;
    color: #fff;
    width: 98%;
    margin: 0 auto;
    margin-top: 10px;
    line-height: 38px;
    text-align: left;
    text-indent: 2em;
    height: 576px;
    overflow: auto;
    /* text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 15; */
}
/* 定义滚动条样式 */
.tcgldw::-webkit-scrollbar {
	width: 2px;
	height: 2px;
	background-color: rgba(240, 240, 240, 0.1);
}
/*定义滚动条轨道 内阴影+圆角*/
.tcgldw::-webkit-scrollbar-track {
	box-shadow: inset 0 0 0px rgba(240, 240, 240, .0);
	border-radius: 10px;
	background-color: rgba(240, 240, 240, .0);
}
/*定义滑块 内阴影+圆角*/
.tcgldw::-webkit-scrollbar-thumb {
	border-radius: 10px;
	box-shadow: inset 0 0 0px rgba(36, 132, 109, .8);
	background-color: rgba(36, 132, 109, .8);
}

.ycboxlt{
    width: 94%; margin-left: 2%;
    background: url(../../assets/images/tckuang.png)no-repeat ;
	background-size: 100% 100%;
    padding: 10px;
}
.ycboxlt4{
    width: 100%; 
    margin-left: 2%;
    // background: url(../../assets/images/tckuang.png)no-repeat ;
	background-size: 100% 100%;
}
.tz_cov_topyqjs{
    width: 100%;
	  height:600px;
}
.tz_cov_top{
    width: 100%;
	  height:600px;
    overflow: auto;
    animation: fadeInLeft 1s 0.02s ease backwards;
}

// 弹出结束
.tcxitit{
	display:block;text-align:left;font-size:14px;color:#fff;margin-left:2%;
}
.tcyqimg{
  width: 100%;
  height: 560px;
}
.tcdidizuoimg{
  width: 40%;
  position: absolute;
  left: 0px;
  bottom: -10px;
  z-index: 0;
}

/* // 右侧文本样式 */
::v-deep .el-timeline-item__content {
  margin-left: 5%;
  width: 92%;
  /* height: 50px; */
  // padding-top: 5px;
}
/* // 时间样式 */
.el-timeline-item__timestamp.is-bottom {
  position: absolute;
  top: 0;
  left: 10%;
  
}
.el-timeline-item__timestamp2 {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #fff;
  text-align: left;
  width: 98%;
  height: 28px;
  line-height: 28px;
  margin-left: -1%;
  padding-left: 3%;
  background: url(../../assets/images/gdtime.png)0 0 / 100% 100%;
  overflow: hidden;
  display: block;
}
/* // 竖线样式 */
::v-deep .el-timeline-item__tail {
  position: absolute!important;
  top: 10px!important;
  left: 5%!important;
  height: 100%!important;
  width: 2px!important;
  opacity: 0.2!important;
  border-left: solid 3px #00FBBE!important;
}
// /* // 圆点样式 */
::v-deep .el-timeline-item__node--normal {
  left: 1%;
  width: 14px;
  height: 14px;
  background: url(../../assets/images/qxyj.png)no-repeat 100% 100%; 
}
::v-deep.el-timeline .el-timeline-item:last-child .el-timeline-item__tail{
  position: absolute!important;
  top: 10px!important;
  left: 2%!important;
  height: 100%!important;
  width: 2px!important;
  opacity: 0.2!important;
  border-left: solid 3px #00FBBE!important;
  display: block;
}
.tz_covstyj_chanye{
  /* // 右侧文本样式 */
  ::v-deep .el-timeline-item__content {
    margin-left: 6%;
    width: 90%;
    /* height: 50px; */
    // padding-top: 5px;
  }
  /* // 时间样式 */
  .el-timeline-item__wrapper{
    top: 0px !important;
  }
  // ::v-deep .el-timeline-item__timestamp.is-bottom {
  //   position: absolute;
  //   top: 0;
  //   left: 10%;
  // }
  // ::v-deep .el-timeline-item__timestamp {
  //   font-family: PingFangSC-Regular;
  //   font-size: 14px;
  //   color: #fff;
  //   text-align: left;
  //   width: 88.4%;
  //   height: 28px;
  //   line-height: 28px;
  //   margin-left: 5%;
  //   padding-left: 3%;
  //   background: url(@/assets/images/jyzt/titleBg.png)  0 0 / 100% 100%;
  // }
  ::v-deep .el-timeline-item__timestamp.is-top{
    margin-bottom: 0px !important;
  }
    /* // 竖线样式 */
    ::v-deep .el-timeline-item__tail {
      position: absolute!important;
      top: 10px!important;
      left: 5%!important;
      height: 100%!important;
      width: 2px!important;
      opacity: 0.2!important;
      border-left: solid 3px #00FBBE!important;
    }
    /* // 圆点样式 */
    ::v-deep .el-timeline-item__node--normal {
      left: 4%;
      width: 14px;
      height: 14px;
      background: url(../../assets/images/qxyj.png)no-repeat 100% 100%; 
      position: absolute;
      left: 5px;
    }
    ::v-deep.el-timeline .el-timeline-item:last-child .el-timeline-item__tail{
      position: absolute!important;
      top: 10px!important;
      left: 3%!important;
      height: 100%!important;
      width: 2px!important;
      opacity: 0.2!important;
      border-left: solid 3px #00FBBE!important;
      display: block;
    }
}
</style>


